




import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
const namespace: string = 'counter';
import AudienceDetailsEditor from '@/components/AudienceDetailsEditor.vue';
import router from '../router';
import BaseView from '../BaseView';
import { AudienceDetails } from '../models/AudienceDetails';
import { AudienceDetailsService } from '../services/AudienceDetailsService';

@Component({
    components: {
        AudienceDetailsEditor
    },
})
export default class CloneAudience extends BaseView {
    @Prop({ default: 0 })
    private audienceId!: number;

    @Prop({ default: '' })
    private detailVersion!: string;

    @Getter('currentClientId', { namespace })
    private clientId!: number;

    private audienceDetailsService!: AudienceDetailsService;

    private isReady: boolean = false;

    private audienceDetails: AudienceDetails;

    constructor() {
        super();
        this.audienceDetails = new AudienceDetails();
    }

    private created() {
        this.getClonedAudienceDetails(this.audienceId, this.detailVersion);
        this.audienceDetailsService = new AudienceDetailsService(this.clientId);
    }

    private getClonedAudienceDetails(audienceID: number, detailVersion: string): void {
        this.showLoader();
        window.App.$axios.get(`/api/audience/api/v1.0/companyid/${this.clientId}/audience/${audienceID}/details/${detailVersion}/clone?api_user=${window.eInsightUserEmail}`)
            .then((response) => {
                this.hideLoader();
                const audienceDetils = this.audienceDetailsService.APIResponseToAudienceDetails(response);
                // Reset these to force the service to create a new audience
                audienceDetils.AudienceID = 0;
                audienceDetils.AudienceDetailsID = 0;

                this.audienceDetails = audienceDetils;

                this.isReady = true;
            });
    }

    private refreshTags() {
        this.$store.dispatch('tag/initializeClient', this.clientId);
    }

    private handleSave(formData: any) {
        this
            .audienceDetailsService
            .SaveAudience(formData, false)
            .then((response) => {
                console.log(response);
                this.successToastPopup('Audience saved successfully.');
                const returnURL = '/';
                this.$router.push(`/audience/${response.data.data.audienceID}/edit/${response.data.data.audienceDetailId}?returnURL=${returnURL}`);
                this.refreshTags();
            })
            .catch((xhr) => {
                console.log('CreateAudience => Save => catch', xhr);
                const payload = xhr.data;
                let validationErrors = 'An unknown error occurred attempting to Save';
                if (payload) {
                    validationErrors = '';
                    for (const i in payload) {
                        if (payload.hasOwnProperty(i)) {
                            validationErrors += `${payload[i][0]}\n`;
                        }
                    }
                }
                this.dangerToastPopup(validationErrors);
            });
    }

    private handleSavePublish(formData: any) {
        this
            .audienceDetailsService
            .SaveAudience(formData, true)
            .then((response) => {
                console.log(response);
                this.successToastPopup('Audience published successfully.');

                // start new counts generation
                const editorRef: any = this.$refs.audienceDetailsEditorRef;
                editorRef.forceStatisticsGeneration(response.data.data.audienceLastPublishDetailId);

                this.refreshTags();

                const returnURL = '/';
                this.$router.push(`/audience/${response.data.data.audienceID}/edit/${response.data.data.audienceDetailId}?returnURL=${returnURL}`);
            })
            .catch((xhr) => {
                console.log('CreateAudience => SavePublish => catch', xhr);
                const payload = xhr.data;
                let validationErrors = 'An unknown error occurred attempting to Save and Publish';
                if (payload) {
                    validationErrors = '';
                    for (const i in payload) {
                        if (payload.hasOwnProperty(i)) {
                            validationErrors += `${payload[i][0]}\n`;
                        }
                    }
                }
                this.dangerToastPopup(validationErrors);
            });
}
}
